import Cookies from 'js-cookie'

const COOKIE_NAME = 'subscription_entry'
// Deciding on a subscription does not take a week, and a stale value would credit this entry
// point for a conversion that started somewhere else. Short enough to bound that, long enough to
// survive abandoning the checkout and coming back the same day.
const EXPIRES_DAYS = 1

// Only production splits the journey across origins: the checkout moves to
// subscriptions.cgtrader.com (routes/20_subscriptions.rb, react_props_helper#subscription_form_url)
// while CTAs are clicked on www, and /subscription in between is a Webflow proxy that cannot
// forward a query param. Scoping to the shared parent is what lets the checkout read this.
// Hardcoded like the Ruby equivalent in session_store.rb: a registrable domain cannot
// be derived correctly from a hostname, and every other environment is single-host, where a
// host-only cookie is what we want.
const SHARED_DOMAIN = '.cgtrader.com'

function cookieDomain() {
  const { hostname } = window.location

  if (hostname === 'cgtrader.com' || hostname.endsWith(SHARED_DOMAIN)) return SHARED_DOMAIN

  return undefined
}

// Removal must repeat path and domain or the browser keeps the original cookie.
function cookieScope() {
  return { path: '/', domain: cookieDomain() }
}

function cookieOptions() {
  return {
    ...cookieScope(),
    expires: EXPIRES_DAYS,
    sameSite: 'lax',
    ...(window.location.protocol === 'https:' && { secure: true }),
  }
}

export function setSubscriptionEntry(entryPoint) {
  if (typeof window === 'undefined' || !entryPoint) return

  try {
    Cookies.set(COOKIE_NAME, entryPoint, cookieOptions())
  } catch {
    // Blocked cookies must never break the CTA that triggered this.
  }
}

export function getSubscriptionEntry() {
  if (typeof window === 'undefined') return null

  try {
    return Cookies.get(COOKIE_NAME) || null
  } catch {
    return null
  }
}

export function clearSubscriptionEntry() {
  if (typeof window === 'undefined') return

  try {
    Cookies.remove(COOKIE_NAME, cookieScope())
  } catch {
    // Nothing to recover: a stale cookie expires on its own.
  }
}
